import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import LessonsPicker from 'views/modals/lessons_picker_modal'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import storefrontActions from 'redux/actions/storefrontActions'

import { storefrontSelectors } from 'redux/selectors'

class StoreFrontLessonsPickerModal extends Component {

	componentDidMount() {
		this.props.actions.init()
	}

	searchLessons() {
		this.props.actions.searchLessons()
	}

	render() {
		/* TRA-KEY */
		return (
			<LessonsPicker
				modalName={'Add Lessons to my Public Library'}
				title={this.props.title}
				subtitle={this.props.subtitle}
				folderName={this.props.folderName}
				placeholder={this.props.placeholder}
				closeModal={this.props.actions.closeModal}
				searchLessons={this.props.actions.searchLessons}
				saveLessons={this.props.actions.saveLessons}
				cancel={this.props.actions.cancel}
				showType={true}
				showPrice={true}
				noop=''
			/>
		)
	}
}

StoreFrontLessonsPickerModal.propTypes = {
	modalName: PropTypes.string,
}

function mapStateToProps(state) {
	return storefrontSelectors.lessonsPickerModalView(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: storefrontActions.lessonsPickerClose,
		searchLessons: storefrontActions.lessonsPickerSearchLessons,
		init: storefrontActions.lessonsPickerInit,
		saveLessons: storefrontActions.lessonsPickerSaveLessons,
		cancel: storefrontActions.lessonsPickerCancel,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreFrontLessonsPickerModal)
